export const ui = {
  page: {
    padding: 24,
    maxWidth: 1100,
    margin: "0 auto",
    color: "#ffffff",
  },

  card: {
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 16,
    padding: 20,
    background: "#10263a",
    marginBottom: 18,
  },

  subCard: {
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: 14,
    padding: 16,
    background: "#10263a",
  },

  input: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.10)",
    background: "#0f2235",
    color: "#ffffff",
    outline: "none",
    boxSizing: "border-box",
    transition: "all 0.2s ease",
  },

  btnPrimary: {
    background: "#f5c542",
    color: "#0b1b2b",
    border: "none",
    padding: "8px 14px",
    borderRadius: 8,
    fontWeight: 600,
    cursor: "pointer",
  },

  btnSecondary: {
    background: "transparent",
    color: "#cbd5e1",
    border: "1px solid #2a3f55",
    padding: "8px 14px",
    borderRadius: 8,
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-block",
  },

  btnDanger: {
    background: "transparent",
    color: "#ef4444",
    border: "1px solid #ef4444",
    padding: "6px 12px",
    borderRadius: 8,
    cursor: "pointer",
  },

  link: {
    color: "#00c2ff",
    textDecoration: "none",
    fontWeight: 600,
  },

  tableTh: {
    textAlign: "left",
    padding: "10px 8px",
    borderBottom: "1px solid rgba(255,255,255,0.10)",
    fontWeight: 700,
    fontSize: 13,
    color: "#dbe7f3",
    whiteSpace: "nowrap",
  },

  tableTd: {
    padding: "10px 8px",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    fontSize: 14,
    color: "#ffffff",
    verticalAlign: "top",
  },
};

export const uiHandlers = {
  focus: {
    onFocus: (e) => {
      e.target.style.border = "1px solid #f5c542";
      e.target.style.boxShadow = "0 0 0 3px rgba(245,197,66,0.12)";
    },
    onBlur: (e) => {
      e.target.style.border = "1px solid rgba(255,255,255,0.10)";
      e.target.style.boxShadow = "none";
    },
  },

  primaryHover: {
    onMouseEnter: (e) => {
      e.target.style.background = "#e0b437";
      e.target.style.transform = "translateY(-1px)";
    },
    onMouseLeave: (e) => {
      e.target.style.background = "#f5c542";
      e.target.style.transform = "translateY(0)";
    },
  },

  secondaryHover: {
    onMouseEnter: (e) => {
      e.target.style.background = "#24374d";
      e.target.style.transform = "translateY(-1px)";
    },
    onMouseLeave: (e) => {
      e.target.style.background = "transparent";
      e.target.style.transform = "translateY(0)";
    },
  },

  rowHover: {
    onMouseEnter: (e) => {
      e.currentTarget.style.background = "rgba(255,255,255,0.04)";
    },
    onMouseLeave: (e) => {
      e.currentTarget.style.background = "transparent";
    },
  },
};
